export type MeasurementStep = {
  id: string
  num: string
  numFA: string
  titleEN: string
  titleFA: string
  bodyEN: string
  bodyFA: string
}

// The four-step measurement method. Visualises the "brief to report" answer
// from the FAQ, delivering on Problem's "we built the measurement layer" claim.
export const measurementSteps: MeasurementStep[] = [
  {
    id: 'baseline',
    num: '01',
    numFA: '۰۱',
    titleEN: 'Baseline',
    titleFA: 'خط مبنا',
    bodyEN:
      "We establish the brand's true starting point before the campaign begins, ensuring every result is measurable and comparable.",
    bodyFA:
      'قبل از شروع کمپین، نقطه شروع واقعی برند را ثبت می‌کنیم؛ تا هر نتیجه، قابل مقایسه باشد.',
  },
  {
    id: 'deploy',
    num: '02',
    numFA: '۰۲',
    titleEN: 'Execution',
    titleFA: 'اجرا',
    bodyEN:
      'Coordinated multi-channel execution with real-time monitoring to optimize performance as it happens.',
    bodyFA:
      'کمپین‌ها به‌صورت هماهنگ در تمام کانال‌ها اجرا می‌شوند؛ با مانیتورینگ لحظه‌ای برای بهینه‌سازی عملکرد.',
  },
  {
    id: 'measure',
    num: '03',
    numFA: '۰۳',
    titleEN: 'Measurement (CPV)',
    titleFA: 'اندازه‌گیری (CPV)',
    bodyEN: 'Cost-Per-View: You only pay for actual, verified video views.',
    bodyFA: 'پرداخت فقط به‌ازای بازدید واقعی ویدیو.',
  },
  {
    id: 'report',
    num: '04',
    numFA: '۰۴',
    titleEN: 'Reporting',
    titleFA: 'گزارش',
    bodyEN: 'From budget to ROI: Everything is transparent, data-driven, and fully reportable.',
    bodyFA: 'از بودجه تا بازده؛ همه‌چیز، شفاف و قابل‌اندازه‌گیری.',
  },
]
